import globals from "imports/globals";
import $ from "cash-dom";
import { getTransitionDuration as dur } from "Utilities";

const component = (function () {
    $(window).on("load", function () {
        if ($("#preloader").length) {
            if (globals.debug) console.log("component-preloader initialized");
            var preloader = $("#preloader");

            setTimeout(function () {
                window.dispatchEvent(new CustomEvent("preloaderHidden"));
                $("html").addClass("preloader-hidden");
                if (globals.debug) console.log("preloader hidden");
            }, dur(preloader[0]));
        }
    });
})();

export default component;
